// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8bvAN","spinner":"styles_spinner__fKPbt"};